import { DistrictSimpleDto } from 'src/app/common/dtos/district.dto';
import { UserDTO } from 'src/app/common/state/user/user.dto';
import { PaginationDTO } from 'src/app/common/types/responses/responses-template';
import { DistrictAPIResponse } from './district-list.responses';

export interface GetAllLmsCoursesAPIResponse {
  items: LmsCourseAPIResponse[];
  _links: {
    self: string;
    first: string;
    last: string;
    prev?: string;
    next?: string;
  };
  _meta: PaginationDTO;
}

export interface ItemLmsCourseAPIResponse {
  item: LmsCourseAPIResponse;
}

export interface LmsCourseAPIResponse {
  id: number;
  title: string;
  creator_user_id: number;
  district_id: number;
  is_shared: number;
  status: LmsCourseStatus;
  preview_link: string;
  district?: DistrictAPIResponse;
  creator?: UserDTO;
  districtsSharedWith?: LmsCourseShareItemResponse[];
  districtsExcludedFrom?: LmsCourseShareItemResponse[];
  registrationCount?: number;
  lastRegistration?: number;
  registrations?: LmsCourseRegistrationAPIResponse[];
  sessionCount?: number;
  created_at: number;
}

export enum LmsCourseStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
  DELETED = 'deleted',
}

export interface LmsCourseShareItemResponse {
  id: number;
  lms_course_id: number;
  district_id: number;
  is_shared: number;
  district: DistrictSimpleDto;
}

export interface GetAllLmsCourseRegistrationsAPIResponse {
  items: LmsCourseRegistrationAPIResponse[];
  _links: {
    self: string;
    first: string;
    last: string;
    prev?: string;
    next?: string;
  };
  _meta: PaginationDTO;
}

export interface LmsCourseRegistrationAPIResponse {
  id: number;
  lms_course_id: number;
  user_id: number;
  launch_link: string;
  percent_complete?: number;
  seconds_tracked?: number;
  user?: UserDTO;
  created_at: number;
  updated_at: number;
}

export interface ShareLmsCourseAPIResponse {
  item: {
    lms_course_id: number;
    district_id: number;
    is_shared: number;
    id: number;
  };
}

export interface UpdateLmsCourseAPIResponse {
  item: LmsCourseAPIResponse;
}
